import React, { Component } from "react";

import ImageActions from "../../actions/imageActions";
import ImageStore from "../../stores/imageStore";

export default class VideoBackground extends Component {
	constructor(props) {
		super(props);

		this.preload = 100;
		this.frameCount = 875;

		this.currentFrame = 1;
		this.lastRenderedFrame = 0;
		this.renderingFrame = 0;

		this.frames = [];
		this.offsetHeight = 0;
		this.scrollHeight = 0;
		this.resize = false;

		this.state = {
			viewHeight: 0,
			viewWidth: 0,
			imageStore: ImageStore.getState()
		};

		this.loading = false;
		this.lastRenderedFrame = 0;

		this.frameStops = [202, 317, 358, 427, 541, 598, 824];
		this.frameStopHold = 25;
	}

	componentDidMount() {
		window.addEventListener("resize", this.onResize);
		document.addEventListener("scroll", this.onScroll);
		if ("scrollRestoration" in history) {
			history.scrollRestoration = "manual";
		}
		const { imageStore } = this.state;

		this.offsetHeight = document.offsetHeight;
		this.scrollHeight = document.scrollHeight;

		ImageStore.listen(this.imageStoreChange);

		this.setState({
			viewHeight: window.innerHeight,
			viewWidth: window.innerWidth
		});

		//this.init();

		// console.log("scroll to top", document.body.scrollTop);

		window.scrollTo(0, 0);
		this.onScroll();
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.onResize);
		document.removeEventListener("scroll", this.onScroll);

		ImageStore.unlisten(this.imageStoreChange);
	}

	shouldComponentUpdate(nextProps, nextState) {
		const { viewWidth, viewHeight } = this.state;
		const { viewWidth: newWidth, viewHeight: newHeight } = nextState;

		return viewHeight !== newHeight || viewWidth !== newWidth;
	}

	imageStoreChange = state => {
		this.setState({ imageStore: state });
		this.updateCanvas();
	};

	//event listeners
	onResize = e => {
		this.setState({
			viewHeight: window.innerHeight,
			viewWidth: window.innerWidth
		});
		this.resize = true;
		this.updateCanvas();
	};

	calcFrame = () => {
		let scrollY = window.scrollY || 0;

		let newFrame = Math.max(
			Math.ceil((scrollY * this.frameCount) / (20000 - window.innerHeight)),
			1
		);

		this.frameStops.map(stopFrame => {
			let endFrame = stopFrame + this.frameStopHold;
			if (newFrame > stopFrame && newFrame < endFrame) {
				newFrame = stopFrame;
			}
			this.currentFrame = newFrame;
		});

		this.currentFrame = newFrame;
	};

	onScroll = e => {
		//console.log("os");
		this.calcFrame();
		this.updateCanvas();
	};

	arrayBufferToBase64 = buffer => {
		var binary = "";
		var bytes = [].slice.call(new Uint8Array(buffer));
		bytes.forEach(b => (binary += String.fromCharCode(b)));
		return window.btoa(binary);
	};

	renderFrame = i => {
		const {
			imageStore: { frames }
		} = this.state;

		//if (!this.frames[Math.min(i + this.preload, this.frameCount)])
		//if ((this.frames[i] && i !== this.lastRenderedFrame) || this.resize) {
		//this.loadFrame(Math.min(i + this.preload, this.frameCount));
		const ctx = this.canvas.getContext("2d");
		this.resize = false;
		//console.log("image drawn", i);
		if (frames[i]) {
			ctx.drawImage(frames[i], 0, 0, window.innerWidth, window.innerHeight);
			this.lastRenderedFrame = i;
			this.props.updateCurrentFrame(i);
			if (this.lastRenderedFrame !== this.currentFrame) this.updateCanvas();
		}
		//} else {
		//this.loadFrame(i);
		//}
	};

	updateCanvas = () => {
		//this.populateBuffer();
		let direction = 0;
		if (this.currentFrame !== this.lastRenderedFrame)
			direction = this.currentFrame > this.lastRenderedFrame ? 1 : -1;

		this.renderingFrame =
			this.currentFrame !== this.renderingFrame
				? Math.abs(this.currentFrame - this.lastRenderedFrame) > 50
					? this.currentFrame + 50 * direction
					: this.lastRenderedFrame + direction
				: this.currentFrame;

		if (this.renderingFrame !== this.lastRenderedFrame || this.resize) {
			window.requestAnimationFrame(() => this.renderFrame(this.renderingFrame));
		}
	};

	render() {
		let { viewWidth, viewHeight } = this.state;
		return (
			<div>
				<canvas
					ref={canvas => {
						this.canvas = canvas;
					}}
					width={viewWidth}
					height={viewHeight}
					style={{
						position: "fixed",
						top: 0,
						zIndex: -1,
						width: "100vw",
						height: "100vh"
					}}
				/>
			</div>
		);
	}
}
